<template>
  <router-view />
</template>

<script>
export default {
  name: 'ClimbingArrivalsIndex'
}
</script>
